
<template>
  <h3 class="com-sub-title" v-html="dataInfo.value"></h3>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin'
export default {
  mixins: [CptMixin],
}
</script>

<style lang="less">
.com-sub-title {
  @import "../../../assets/css/inner-html.less"; 
  margin: 20px 0 10px;
  font-size: 17px;
  font-weight: 700;
  color: rgb(40, 50, 60);
  line-height: 22px;
  word-break: break-all;
  word-wrap: break-word;
}
</style>